import {createFileRoute} from '@tanstack/react-router'

import {AppShellLayout} from '../app-shell/app-shell-layout'
import {requireAuthenticatedBeforeLoad} from '../auth/require-authenticated-before-load'

export const Route = createFileRoute('/_app')({
    beforeLoad: requireAuthenticatedBeforeLoad,
    component: AppShellLayout,
})
